import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import { pixelTheme } from '../../theme/pixelTheme';

export const Header = styled.header`
  padding: 0.5rem;
  background: ${pixelTheme.colors.dark};
  min-height: 75px;
  border-bottom: 4px solid ${pixelTheme.colors.primary};
  box-shadow: 0 4px 0 0 rgba(0,0,0,0.3);
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      ${pixelTheme.colors.accent} 0%,
      ${pixelTheme.colors.primary} 50%,
      ${pixelTheme.colors.accent} 100%
    );
    animation: slide 3s linear infinite;
  }
  
  @keyframes slide {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1280px;
  padding-right: 25px;
  padding-left: 25px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const NavLink = styled.div`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled.div`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const ContactWrapper = styled.div`
  cursor: pointer;
  width: ${(props) => (props.width ? '100%' : '110px')};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
  color: ${pixelTheme.colors.light};
`;

export const Burger = styled.div`
  display: none;
  align-items: center;
  padding: 0.5rem 1.25rem;
  
  @media only screen and (max-width: 768px) {
    display: flex !important;
  }
`;

export const NotHidden = styled.div`
  display: flex;
  align-items: center;
  
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const Menu = styled.h5`
  font-family: 'Pixelify Sans', monospace;
  font-size: 18px;
  margin-top: -0.45rem;
  padding: 0 1.56rem 0 0;
  font-weight: 700;
  border-bottom: 3px solid ${pixelTheme.colors.primary};
  color: ${pixelTheme.colors.light};
  text-transform: uppercase;
  letter-spacing: 2px;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 600;
  color: ${pixelTheme.colors.light};
  transition: all 0.1s steps(3);
  margin: 0 1.5rem;
  text-transform: uppercase;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  
  &:hover {
    color: ${pixelTheme.colors.accent};
    transform: scale(1.1);
    
    &:before {
      content: '>';
      position: absolute;
      left: -15px;
      top: 50%;
      transform: translateY(-50%);
      animation: blink 0.5s infinite;
    }
  }
  
  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
    height: auto;
  }
`;

export const Label = styled.span`
  font-family: 'Pixelify Sans', monospace;
  font-size: 14px;
  font-weight: 500;
  color: ${pixelTheme.colors.light};
  text-align: right;
  display: flex;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
  padding-right: ${(props) => (props.padding ? '10px' : '')};
  color: ${pixelTheme.colors.light};
  
  &:hover {
    color: ${pixelTheme.colors.accent};
    transform: rotate(90deg);
    transition: all 0.3s steps(8);
  }
`;

export const Span = styled.span`
  cursor: pointer;
  color: ${pixelTheme.colors.light};
`;
